module.exports = __webpack_public_path__ + "img/student.af1f6da7.png";